<span [ngClass]="inputClass" [ngStyle]="{
      width: width + 'px',
      height: width + 'px'
    }" class="spinner"></span>